import { FULL_BULLETINS, GLOBAL_CATALOGS } from '../types';

const initialState = {
  isLoading: false,
  menus: [],
  value: GLOBAL_CATALOGS.Bulletins.LatestNews.List,
  filter: {
    service: GLOBAL_CATALOGS.Bulletins.LatestNews.List,
  },
  news: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  announcements: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  details: {},
};

const bulletinsReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_BULLETINS.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case FULL_BULLETINS.Value: {
      return {
        ...state,
        value: action.payload
      };
    }
    case FULL_BULLETINS.FilterService: {
      return {
        ...state,
        filter: { ...state.filter, service: action.payload }
      };
    }
    case GLOBAL_CATALOGS.Bulletins.Root: {
      return {
        ...state,
        menus: action.payload
      };
    }
    case GLOBAL_CATALOGS.Bulletins.LatestNews.List: {
      return {
        ...state,
        news: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Bulletins.Announcement.List: {
      return {
        ...state,
        announcements: { ...action.payload }
      };
    }
    default: {
      return state;
    }
  }
};

export default bulletinsReducer;
